import dictionary from './dictionary'
import dashboard from './dashboard'
import manage from './manage'
import report from './report'

// Array of sections
export default [...dashboard, ...manage, ...dictionary, ...report]

